module.exports = __webpack_public_path__ + "teqbahn-assets/media/res1.0ba4344c.png";